<template>
	<SearchApp v-if="showSearchApp" />
	<EmarsysToast />
	<SharedToast />
	<SharedBanner />
	<WelcomeModal />
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import SearchApp from "@/SearchApp/SearchApp.vue";
import SharedToast from "@/SharedToastApp/SharedToast.vue";
import SharedBanner from "@/SharedBannerApp/SharedBanner.vue";
import EmarsysToast from "@/EmarsysToastApp/EmarsysToast.vue";
import WelcomeModal from "@/WelcomeModalApp/WelcomeModal.vue";

const showSearchApp = ref(false);

onMounted(() => {
	showSearchApp.value = !!(window.ocm.config.hasSearch && document.getElementById("header-search-container"));
});
</script>
